"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _icons = _interopRequireDefault(require("./constants/icons"));
var _AppInformation = _interopRequireDefault(require("./styles/AppInformation"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var resolveENVVariable = function resolveENVVariable(str) {
  return (str || '').trim();
};
function resolveLabel(b, v) {
  var label = '';
  if (b) {
    label += "Branch ".concat(b);
  }
  if (b && v) {
    label += ', ';
  }
  if (v) {
    label += "Version ".concat(v);
  }
  return label;
}
function AppInformation(_ref) {
  var branch = _ref.branch,
    version = _ref.version;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    hovered = _useState2[0],
    setHovered = _useState2[1];
  if (!branch && !version) {
    return null;
  }
  var codeBranch = resolveENVVariable(branch);
  var appVersion = resolveENVVariable(version);
  var ariaLabel = resolveLabel(codeBranch, appVersion);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('app-information', _AppInformation["default"].appInformation),
    "data-icon": _icons["default"].info,
    onMouseEnter: function onMouseEnter() {
      return setHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHovered(false);
    },
    "aria-label": ariaLabel
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('app-information__detail', _AppInformation["default"].appInformation__detail, (0, _defineProperty2["default"])({
      'app-information__detail--visible': hovered
    }, _AppInformation["default"].appInformation__detail_visible, hovered))
  }, codeBranch && /*#__PURE__*/_react["default"].createElement("span", null, "Branch: ", codeBranch), !!codeBranch && !!appVersion && /*#__PURE__*/_react["default"].createElement("br", null), appVersion && /*#__PURE__*/_react["default"].createElement("span", null, "Version: ", appVersion)));
}
AppInformation.displayName = 'AppInformation';
var _default = exports["default"] = AppInformation;